var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
/* eslint-disable no-restricted-imports */
import { ZERO_ADDRESS } from '../../../../constants/misc';
import { Contract } from '@ethersproject/contracts';
import { JsonRpcProvider } from '@ethersproject/providers';
import { createPlugin } from '../../../../Fct/createPlugin';
import { FctAddress, FctValue } from '../../../../Fct/generics/FctParams';
import cTokens from '../../../../Fct/tokens/cTokens.json';
import { compoundTokens, isNative } from '../constants';
export var Mint = createPlugin({
    protocol: 'COMPOUND_V2',
    type: 'ACTION',
    method: 'mint',
    name: 'mint',
    description: 'Mint cTokens',
    getParams: function (_a) {
        var chainId = _a.chainId;
        return ({
            input: {
                to: new FctAddress({
                    destination: 'ctoken',
                    options: compoundTokens.filter(function (token) { return token.chainId === Number(chainId); }),
                }),
                payToken: new FctAddress({
                    destination: 'erc20',
                    readonly: true,
                }),
                value: new FctValue({ destination: 'wei_amount', required: false, readonly: true }),
                amount: new FctValue({ destination: 'wei_amount' }),
                methodParams: {
                    mintAmount: new FctValue({ destination: 'wei_amount', required: false, readonly: true }),
                },
            },
            output: {},
        });
    },
    calculateValuesOnUserInput: function (_a) {
        var input = _a.input, chainId = _a.chainId, provider = _a.provider;
        var getParamsAsync = function () { return __awaiter(void 0, void 0, void 0, function () {
            var to, value, amount, payToken, methodParams, underlyingToken, tokenContract, symbol, decimals, _a, _b, _c;
            var _d;
            return __generator(this, function (_e) {
                switch (_e.label) {
                    case 0:
                        to = input.to, value = input.value, amount = input.amount, payToken = input.payToken, methodParams = input.methodParams;
                        if (!to.value || to.isVariable) {
                            return [2 /*return*/, {
                                    params: { value: undefined, payToken: undefined, methodParams: { mintAmount: undefined } },
                                    error: undefined,
                                }];
                        }
                        if (isNative(to.value, chainId)) {
                            value.value = amount.value;
                            methodParams.mintAmount.value = undefined;
                            methodParams.mintAmount.virtual = true;
                            methodParams.mintAmount.required = false;
                            value.required = true;
                            amount.label = 'ETH Amount';
                            amount.decimals = 18;
                            payToken.label = 'ETH';
                            payToken.decimals = 18;
                            payToken.value = ZERO_ADDRESS;
                            return [2 /*return*/, {
                                    params: { value: amount.value, payToken: ZERO_ADDRESS },
                                    error: undefined,
                                }];
                        }
                        underlyingToken = (_d = cTokens.find(function (cToken) {
                            if (typeof to.value === 'string' && cToken.address.toLowerCase() === to.value.toLowerCase())
                                return true;
                            return false;
                        })) === null || _d === void 0 ? void 0 : _d.assetAddress;
                        if (!underlyingToken) return [3 /*break*/, 5];
                        tokenContract = new Contract(underlyingToken, ['function decimals() view returns (uint8 decimals)', 'function symbol() view returns (string symbol)'], provider);
                        return [4 /*yield*/, tokenContract.symbol()];
                    case 1:
                        symbol = _e.sent();
                        return [4 /*yield*/, tokenContract.decimals()];
                    case 2:
                        decimals = _e.sent();
                        _a = amount;
                        _b = "".concat;
                        return [4 /*yield*/, tokenContract.symbol()];
                    case 3:
                        _a.label = _b.apply("", [_e.sent(), " Amount"]);
                        _c = amount;
                        return [4 /*yield*/, tokenContract.decimals()];
                    case 4:
                        _c.decimals = _e.sent();
                        payToken.label = symbol;
                        payToken.decimals = decimals;
                        payToken.value = underlyingToken;
                        _e.label = 5;
                    case 5:
                        methodParams.mintAmount.required = true;
                        value.required = false;
                        value.value = '0';
                        methodParams.mintAmount.value = amount.value;
                        methodParams.mintAmount.virtual = false;
                        return [2 /*return*/, {
                                params: { value: undefined, payToken: underlyingToken, methodParams: { mintAmount: amount.value } },
                                error: undefined,
                            }];
                }
            });
        }); };
        return { get: getParamsAsync, depParamKeys: ['to', 'amount'] };
    },
    requiredApprovals: function (params, chainId) {
        var _a;
        if (!params.to.value)
            return [];
        if (isNative(params.to.value, chainId))
            return [];
        var underlyingToken = (_a = cTokens.find(function (cToken) {
            if (typeof (params === null || params === void 0 ? void 0 : params.to.value) === 'string' && cToken.address.toLowerCase() === (params === null || params === void 0 ? void 0 : params.to.value.toLowerCase()))
                return true;
            return false;
        })) === null || _a === void 0 ? void 0 : _a.assetAddress;
        return [
            {
                to: underlyingToken,
                params: { spender: params === null || params === void 0 ? void 0 : params.to.value, amount: params.methodParams.mintAmount.value },
                method: 'approve',
                protocol: 'ERC20',
            },
        ];
    },
    assetFlow: function (params, chainId, _walletAddress, vaultAddress) {
        var _a;
        return __awaiter(this, void 0, void 0, function () {
            var to, amount, asset, cToken, exchangeRate, cTokens;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        to = params.to, amount = params.amount;
                        if (!to.value || !amount.value || !vaultAddress)
                            return [2 /*return*/, []];
                        if (typeof to.value !== 'string' || typeof amount.value !== 'string')
                            return [2 /*return*/, []
                                // Find asset from cToken address
                            ];
                        asset = (to === null || to === void 0 ? void 0 : to.value) &&
                            (((_a = compoundTokens.find(function (token) { return token.address === to.value; })) === null || _a === void 0 ? void 0 : _a.assetAddress) || ZERO_ADDRESS);
                        if (!asset)
                            return [2 /*return*/, []
                                // TODO: cToken amount needs to be calculated off chain.
                            ];
                        cToken = new Contract(to.value, [
                            'function exchangeRateStored() view returns (uint256 exchangeRate)',
                            'function reserveFactorMantissa() view returns (uint256)',
                        ], new JsonRpcProvider());
                        return [4 /*yield*/, cToken.exchangeRateStored()]; // 232198806587247
                    case 1:
                        exchangeRate = _b.sent() // 232198806587247
                        ;
                        cTokens = (BigInt(amount.value) * BigInt(Math.pow(10, 18))) / exchangeRate;
                        return [2 /*return*/, [
                                {
                                    address: vaultAddress,
                                    toSpend: [
                                        {
                                            token: asset,
                                            amount: amount.value,
                                        },
                                    ],
                                    toReceive: [
                                        {
                                            token: to.value,
                                            amount: cTokens.toString(),
                                        },
                                    ],
                                },
                            ]];
                }
            });
        });
    },
});
